import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import { AccountingDocumentEntity } from '../../../../api/types/accounting/accounting-documents-entity';
import { AccountingDocumentsFilterType } from '../accounting-documents-filter.type';

export const getAccountingDocumentsListOperation = async (
  filters: AccountingDocumentsFilterType,
  offset: number,
  limit: number,
  setData: (data: AccountingDocumentEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const trimmedDescription = filters.itemDescriptionSubText?.trim() ?? '';
    const trimmedLast4 = filters.creditCardLast4Digit?.trim() ?? '';

    const res = await appApi.getAccountingDocumentsList({
      offset,
      limit,
      accountingType: filters.accountingType ?? null,
      serialNumber: filters.serialNumber ?? null,
      startSerialNumber: filters.startSerialNumber ?? null,
      endSerialNumber: filters.endSerialNumber ?? null,
      startFromDate: filters.startFromDate ?? null,
      toDate: filters.toDate ?? null,
      paymentMethod: filters.paymentMethod ?? null,
      creditCardCompany: filters.creditCardCompany ?? [],
      amount: filters.amount ?? null,
      amountFrom: filters.amountFrom ?? null,
      amountTo: filters.amountTo ?? null,
      paymentServiceIds: filters.paymentServiceIds ?? [],
      itemDescriptionSubText:
        trimmedDescription === '' ? null : trimmedDescription,
      showCrmDocuments: filters.showCrmDocuments,
      showStudentDocument: filters.showStudentDocument,
      creditCardLast4Digit: trimmedLast4 === '' ? null : trimmedLast4,
      // Backend requires `branchIds` on every request (empty = no branch filter).
      branchIds: filters.branchIds ?? [],
      includeDocumentWithNoBranch: filters.includeDocumentWithNoBranch,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body.data ?? []);
    setTotal(res.data.body.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
